import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';

import Badge from 'components/common/Badge';

const styles = theme => ({
  listItem: {
    color: theme.palette.text.primary,
    minWidth: 140,
    padding: 0,
    '& + $listItem': {
      paddingTop: 15,
    },
  },
});

const OrdersTableRowInsurances = ({ Insurance, classes, ...otherProps }) => (
  <List disablePadding>
    {Insurance.map((item) => {
      const itemInsuranceParam = otherProps['Order Insurance Param'] && otherProps['Order Insurance Param'].length > 0
        ? otherProps['Order Insurance Param'].find(insuranceParam => insuranceParam['Insurance ID'] === item.ID) : null;
        return (
        <ListItem
          key={item.ID}
          className={classes.listItem}
        >
          {item['Order Benefits'] &&
            <Badge color="primary" gutter="right">
              {item['Order Benefits'] === 'Primary' && '1'}
              {item['Order Benefits'] === 'Secondary' && '2'}
              {item['Order Benefits'] === 'Secondary As Primary' && '2'}
              {item['Order Benefits'] === 'Tertiary' && '3'}
            </Badge>
          }
          {item['Insurance Type'] === 'Self' ? 'Self Payer' : item['Payer Name']}
          {itemInsuranceParam ?
            <Fragment>
              {`| Authorization: ${itemInsuranceParam.Authorization}`}
              {itemInsuranceParam['Authorization From'] &&
                ` (${itemInsuranceParam['Authorization From']}-${itemInsuranceParam['Authorization To']})`}
              {itemInsuranceParam.Resubmission &&
                `| Resubmission: ${itemInsuranceParam.Resubmission}`}
              {itemInsuranceParam['Original Ref Number'] &&
                `| Reference: ${itemInsuranceParam['Original Ref Number']}`}
            </Fragment> : ''}
        </ListItem>
      );
    })}
  </List>
);

OrdersTableRowInsurances.propTypes = {
  Insurance: PropTypes.arrayOf(
    PropTypes.shape({
      ID: PropTypes.number.isRequired,
      'Order Benefits': PropTypes.string,
      'Insurance Info': PropTypes.shape({
        'Payer Name': PropTypes.string,
      }),
    }),
  ).isRequired,
  classes: PropTypes.shape({
    listItem: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(OrdersTableRowInsurances);



// WEBPACK FOOTER //
// ./src/components/workflow/OrdersTable/OrdersTableRowInsurances.js